import { createStore } from '@aibees/shared/store';
import { SnackbarProgressStoreData as StoreData } from './types';

const useSnackbarProgressStore = createStore<StoreData>(
  'snackbar-progress',
  (set) => ({
    progress: new Map(),
    setProgress: (key, value) =>
      set((state) => {
        const newProgress = new Map(state.progress);
        newProgress.set(key, value);
        return { progress: newProgress };
      }),
    removeProgress: (key) =>
      set((state) => {
        const newProgress = new Map(state.progress);
        newProgress.delete(key);
        return { progress: newProgress };
      }),
  })
);

export default useSnackbarProgressStore;
